import { uiApi } from "$lib/ui-api";
import type { INewProductUI } from "../+page.server";
import { SellerPreference, utils } from "$lib/utils";

export enum PLATFORM {
  WEB = "ticketpad",
}
export enum SortOption {
  // NONE = "0",
  LOW_TO_HIGH = "1",
  HIGH_TO_LOW = "2",
}
export class FixtureProductManager {
  // Products
  public displayList: INewProductUI[] = [];
  public originalProducts: INewProductUI[] = [];
  private availableBlocks = new Set<string>();
  private availableCategories = new Map<string, { title: string; colour: string }>();
  private ticketFormat = new Map<string, string>();

  constructor(
    private eventuuid: string,
    private apiUrl: string
  ) {}

  public init(initProducts: INewProductUI[] = []) {
    if (!initProducts.length) {
      return;
    }
    // Set all Tickets
    this.originalProducts = [...initProducts].filter(v => {
      const retVal = v.qty > 0;
      if (retVal) {
        // Get list of availableTicketCategories
        const value = v.ticketCategory.value as string;
        this.availableCategories.set(value, {
          title: v.ticketCategory.title as string,
          colour: v.ticketCategory.colour as string,
        });

        const format = v.ticketFormat.title;
        this.ticketFormat.set(utils.slugify(format), format);
        // Get list of availableBlocks
        v.block.forEach(b => this.availableBlocks.add(`${b.toLowerCase()}`));
        return v;
      }
    });

    this.displayList = [...this.originalProducts];
  }

  public get getOriginalProducts() {
    return this.originalProducts;
  }

  public async refresh(services: string[] = [], cacheName: string) {
    const resp = await uiApi.getRaw(`${this.apiUrl}/refresh-products`, {
      eventuuid: this.eventuuid,
      rProds: services,
      cacheName,
    });
    if (!resp.ok) {
      // If problem in the response, return platform products only
      // Reset original products excluding 3rd part
      this.init(this.originalProducts.filter(v => v.productPlatform === PLATFORM.WEB));
      return;
    }
    // Get all the product on refresh
    const latestProducts = ((await resp.json()) as INewProductUI[]) || [];
    this.init(latestProducts);
  }

  public get getAvailableBlocks() {
    return this.availableBlocks;
  }

  public get getAvailableCategories() {
    return this.availableCategories;
  }

  public get getAvailableTicketFormat() {
    return this.ticketFormat;
  }
  // Not used for now but working
  public getMinAndMAxPrice() {
    let min = this.displayList[0]?.proceedPrice || 100000;
    let max = this.displayList[0]?.proceedPrice || 0;
    for (const row of this.displayList) {
      const proceedPrice = row?.proceedPrice;
      if (proceedPrice < min) {
        min = proceedPrice;
      }
      if (proceedPrice > max) {
        max = proceedPrice;
      }
    }
    return { min, max };
  }

  // Filter options for products
  public sortOptionFn(value: string) {
    switch (value) {
      case SortOption.HIGH_TO_LOW:
        this.displayList.sort(({ proceedPrice: a }: INewProductUI, { proceedPrice: b }: INewProductUI) =>
          +a > +b ? -1 : +a < +b ? 1 : 0
        );
        break;

      case SortOption.LOW_TO_HIGH:
      default:
        this.displayList.sort(({ proceedPrice: a }: INewProductUI, { proceedPrice: b }: INewProductUI) =>
          +a < +b ? -1 : +a > +b ? 1 : 0
        );
        break;
    }
  }

  public runFilter(args: IFilterOption) {
    const results: INewProductUI[] = [];
    // If reset
    if (args?.reset) {
      this.displayList = this.originalProducts;
      return;
    }

    // Used for filter in UI with single category for now
    for (const row of this.originalProducts) {
      const { sellPreference, qty } = row;

      const anyQty = args.userQty === 0;
      switch (sellPreference) {
        case SellerPreference.ALL_TOGETHER: {
          if (qty === args.userQty || anyQty) {
            this.filterSingle(results, row, args);
          }
          break;
        }
        case SellerPreference.AVOID_LEAVING_ONE_TICKET: {
          const avOne = utils.avoidLeaveOne(qty);
          if (avOne.includes(qty) || anyQty) {
            this.filterSingle(results, row, args);
          }
          break;
        }
        case SellerPreference.IN_PAIRS: {
          const res = utils.inPairs(qty) || anyQty;
          if (res.includes(qty)) {
            this.filterSingle(results, row, args);
          }
          break;
        }
        default: {
          // No preference
          this.filterSingle(results, row, args);
          break;
        }
      }
    }
    this.displayList = [...results];
  }

  public filterSingle(results: INewProductUI[], row: INewProductUI, args: IFilterOption) {
    const {
      category = [],
      // min = 0,
      // max = 1000000,
      // ticketFormat: userFormat = "all",
      together = true,
      userQty = 1,
    } = args;
    const { qty, ticketCategory, singleSeat, block } = row;

    if (qty < +userQty) {
      // If less of user quantity
      return;
    }
    // Ticket Type all will no filter
    // if (userFormat !== "all") {
    //   if (ticketFormat.title.toLowerCase() !== userFormat) {
    //     // If not match mobile/paper
    //     return;
    //   }
    // }

    // if (!(+proceedPrice >= +min && +proceedPrice <= max)) {
    //   // If price is not in range
    //   return;
    // }

    // If together is click but the ticket is single seat return
    if (together && singleSeat) {
      return;
    }

    if (args?.block) {
      const blocks = block.map(v => v.toLowerCase());
      const isBlock = blocks.includes(args?.block || "");
      // If block is available
      if (isBlock) {
        results.push(row);
      }
      return;
    }

    if (!category?.length) {
      // No mater what section
      results.push(row);
      return;
    }

    if (!category.includes(ticketCategory?.value || "")) {
      // No matching section choose
      return;
    }

    // Matching all the conditon
    results.push(row);
    return;
  }
}

export interface IFilterOption {
  category?: string | string[];
  min?: number;
  max?: number;
  block?: string;
  ticketFormat?: string;
  together?: boolean;
  userQty?: number;
  reset?: boolean;
}
